import script from "./flightSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./flightSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./flightSwitch.vue?vue&type=style&index=0&id=47540147&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47540147"]])

export default __exports__